// src/components/filter.
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Link, useNavigate, useLocation, useParams } from "react-router-dom";
import { Table, Col, Row, UncontrolledTooltip, Input } from "reactstrap";
import moment from "moment";

//import components
import Breadcrumbs from "components/_Common/Breadcrumb";
import DeleteModal from "components/_Common/DeleteModal";
import { useDispatch, useSelector } from "react-redux";

// actions
import {
  deleteParticipants,
  listParticipants,
  listParticipantStatus,
  sendInvitationMail,
} from "store/actions";
import ParticipantsAddEditModal from "../AddEdit/ParticipantsAddEditModal ";
import toastr from "toastr";
import MyPagination from "components/_Common/MyPagination";
import { MdArrowBackIos } from "react-icons/md";
import { withTranslation } from "react-i18next";
import { GrDrag } from "react-icons/gr";
import { FaFilePdf } from "react-icons/fa";
import { CopyToClipboard } from "react-copy-to-clipboard";
import CSVUploadModal from "../AddEdit/CSVUploadModal";
import {
  onPeersMerge,
  onParticipantScorePDF,
  pdfDownload,
} from "helpers/backend_api_helper";
import { MdDownloadForOffline } from "react-icons/md";
import { HiRefresh } from "react-icons/hi";
import { MdRefresh } from "react-icons/md";
import axios from "axios";

const ParticipantsList = (props) => {
  //meta title
  document.title = `${props.t("Participants")} | ${props.t("Admin")}`;

  const { error, success, loading } = useSelector((state) => ({
    loading: state.Batches.loading,
    error: state.Batches.error,
    success: state.Batches.success,
  }));

  const handleCopy = () => {
    toastr.success(props.t("Copied!!"));
  };

  const dispatch = useDispatch();
  const { state } = useLocation();
  const navigate = useNavigate();
  const [modal, setModal] = useState(false);
  const [csvModal, setCSVModal] = useState(false);
  const [itemData, SetItemData] = useState();
  const [tableData, SetTableData] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [filterData, setFilterData] = useState({
    limit: 25,
    page: currentPage,
    search: "",
  });
  const [isDownloadPdf, setIsDownloadPdf] = useState(false);
  const [participantId, setParticipantId] = useState(null)
  // const [batchId, setBatchId] = useState(state?.batchData?.id);
  const { batchId } = useParams();

  const toggle = () => {
    if (modal) {
      setModal(false);
    } else {
      setModal(true);
    }
  };

  const toggleCSV = () => {
    if (csvModal) {
      setCSVModal(false);
    } else {
      setCSVModal(true);
    }
  };

  //delete question
  const [deleteModal, setDeleteModal] = useState(false);
  const onClickDelete = (item) => {
    SetItemData(item);
    setDeleteModal(true);
  };
  const handleDeleteParticipants = () => {
    dispatch(
      deleteParticipants({ ids: [itemData?.id] }, (res) => {
        if (res?.status === "success") {
          setDeleteModal(false);
          toastr.success(res?.message);
          fetchParticipantsList(filterData);
          setFilterData((prevFilterData) => ({
            ...prevFilterData,
            randomEvent: Math.random(),
          }));
        } else {
          toastr.error(res?.message);
        }
      })
    );
  };

  // edit
  const handleParticipantsClick = (data) => {
    setIsEdit(true);
    SetItemData(data);
    toggle();
  };

  // list
  const fetchParticipantsList = (filterData) => {
    dispatch(
      listParticipants(filterData, batchId, (res) => {
        if (res?.status === "success") {
          SetTableData(res?.data);
          SetItemData({});
        }
      })
    );
  };
  useEffect(() => {
    fetchParticipantsList(filterData);
  }, [
    currentPage,
    filterData?.search,
    filterData?.limit,
    filterData?.question_type,
  ]);

  // filter
  const debounce = (func, delay) => {
    let timer;
    return function (...args) {
      clearTimeout(timer);
      timer = setTimeout(() => func.apply(this, args), delay);
    };
  };

  // Function to handle search
  const handleSearch = debounce((searchTerm) => {
    setFilterData((prevFilterData) => ({
      ...prevFilterData,
      search: searchTerm,
    }));
  }, 500);

  const handleLimit = (val) => {
    setFilterData((prevFilterData) => ({
      ...prevFilterData,
      limit: val,
    }));
  };

  // delete selecetd
  const [deleteIds, setDeleteIds] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  const toggleSelectAll = () => {
    setSelectAll(!selectAll);
    const ids = selectAll
      ? []
      : tableData?.participants?.map((item) => item.id);
    setDeleteIds(ids || []);
  };

  const onChangeSelectDelete = (id) => {
    const updatedDeleteIds = deleteIds.includes(id)
      ? deleteIds.filter((deleteId) => deleteId !== id)
      : [...deleteIds, id];
    setDeleteIds(updatedDeleteIds);
  };

  const onDeleteSelected = () => {
    deleteIds.length > 0 &&
      dispatch(
        deleteParticipants({ ids: [...deleteIds] }, (res) => {
          if (res?.status === "success") {
            setDeleteModal(false);
            toastr.success(res?.message);
            fetchParticipantsList(filterData);
            setFilterData((prevFilterData) => ({
              ...prevFilterData,
              randomEvent: Math.random(),
            }));
            setDeleteIds([]);
            setSelectAll(false);
            setMultiDeleteModal(false);
          } else {
            toastr.error(res?.message);
            setMultiDeleteModal(false);
          }
        })
      );
  };

  // send invitation mail
  const [mailData, setMailData] = useState({});
  const onSendInvitationMail = (data) => {
    dispatch(
      sendInvitationMail(data?.id, (res) => {
        if (res?.status === "success") {
          if (res?.data?.invitationMethod != "username") {
            toastr.success(res?.message);
          }
          if (res?.data?.invitationMethod == "username") {
            const recipients = "";
            const subject = res?.data?.subject;
            const body = res?.data?.bodyHtml;
            // const encodedBody = encodeURIComponent(body.replace(/\n/g, '<br>'));
            const bodyPlain = encodeURIComponent(
              body
                .replace(/<br\s*\/?>/gi, "\n") // Replace <br> tags with newlines
                .replace(/<[^>]+>/g, "")
            );

            const mailtoLink = `mailto:${recipients}?subject=${encodeURIComponent(
              subject
            )}&body=${bodyPlain}`;

            window.location.href = mailtoLink;
          }
          fetchParticipantsList(filterData);
          setMailData({});
        } else {
          setMailData({});
          toastr.error(res?.message);
        }
      })
    );
  };
  useEffect(() => {
    if (error) {
      toastr.error(error);
      setMailData({});
    }
  }, [error]);

  const peersMerge = async (id) => {
    try {
      const response = await onPeersMerge(id);
      if (response?.status == "success") {
        toastr.success(response?.message);
        fetchParticipantsList(filterData);
      }
    } catch (error) {
      // toastr.error()
    }
  };

  // create ZIP
  const [zipLoading, setZipLoading] = useState(false);
  const [itemId, setItemId] = useState(null);
  const [intervalId, setIntervalId] = useState(null);
  const [isClicked, setIsClicked] = useState(false);

  const checBatchStatus = async () => {
    dispatch(
      listParticipantStatus(filterData, batchId, (res) => {
        if (res?.status === "success") {

          // console.log(res.data.participants, "####################", error, success, loading)
          // const allStatusesAreC = res.data.participants.every(item => item.cronStatus === "C");

          // const allStatusesAreC = res.data.participants.every(
          //   item => item.cronStatus === "C" || item.cronStatus === "I"
          // );

          // if (allStatusesAreC) {
          //   // console.log(allStatusesAreC);
          //   fetchParticipantsList(filterData);
          //   SetItemData({});
          //   clearInterval(intervalId);
          //   setIsClicked(false)
          // }
          const oldPCount = JSON.parse(localStorage.getItem('participantsWithPCount'))

          // const participantsWithP = res.data.participants.filter(participant => participant.cronStatus === "P");
          const participantsWithPAndI = res.data.participants.filter(
            participant => participant.cronStatus === "P" || participant.cronStatus === "I"
          );
          const countP = participantsWithPAndI.length;

          localStorage.setItem("participantsWithPCount", countP);

          const getPCount = JSON.parse(localStorage.getItem('participantsWithPCount'));

          // console.log("oldPCount ?????????????" ,oldPCount)
          // console.log("countP ?????????????" ,countP)


          if ((getPCount === 0) && (countP == 0)) {
            fetchParticipantsList(filterData);
            // SetItemData({});
            clearInterval(intervalId);
            setIsClicked(false);
            localStorage.removeItem('participantsWithPCount');
            return false
          }

          if (oldPCount != countP) {
            fetchParticipantsList(filterData);
          }




        }
      })
    );
  }


  useEffect(() => {


    if (isClicked) {
      const id = setInterval(checBatchStatus, 10000);

      setIntervalId(id);

      return () => clearInterval(id);
    }


    return undefined;
  }, [isClicked]);

  const onCreateZip = async (batchId) => {
    setItemId(batchId);
    setZipLoading(true);
    try {
      const createGroupReport = await onParticipantScorePDF(batchId);
      if (createGroupReport?.status) {
        toastr.success(createGroupReport?.message);
        setIsClicked(true)
        checBatchStatus()
        fetchParticipantsList(filterData);
        setZipLoading(false);
        setItemId(null);
      } else {
        toastr.error(createGroupReport?.message);
        setZipLoading(false);
        setItemId(null);
      }
    } catch (error) {
      console.log(error)
      toastr.error("Server Error");
      setZipLoading(false);
      setItemId(null);
    }
  };

  const downloadPdf = async (token, itemId) => {
    try {
      let baseUrl = process.env.REACT_APP_ENV == "development" ? process.env.REACT_APP_API_DEV_BASE_URL : process.env.REACT_APP_API_PROD_BASE_URL
      setIsDownloadPdf(true)
      setParticipantId(itemId)
      const response = await axios.get(
        `${baseUrl}/api/v1/utility/file-preview/${token}`
      );
      // console.log(itemId, "response", response.status)
      if (response.status == 200) {
        setIsDownloadPdf(false)
      }
      if (response?.status_code == "400") {
        return toastr.error(response?.message);
      } else {
        window.open(
          `${baseUrl}/api/v1/utility/file-preview/${token}`
        );
      }
    } catch (error) { }
  };

  const [multiDeleteModal, setMultiDeleteModal] = useState(false);
  const onClickMultiDelete = () => {
    setMultiDeleteModal(true);
  };

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteParticipants}
        onCloseClick={() => setDeleteModal(false)}
        loading={loading}
        modalContent={props.t("Are you sure delete Schor Text ?")}
      />
      <DeleteModal
        show={multiDeleteModal}
        onDeleteClick={onDeleteSelected}
        onCloseClick={() => setMultiDeleteModal(false)}
        loading={loading}
        modalContent="Are you sure delete Question?"
      />
      <ParticipantsAddEditModal
        modal={modal}
        toggle={toggle}
        isEdit={isEdit}
        batchId={batchId}
        itemData={itemData}
        SetItemData={SetItemData}
        fetchParticipantsListData={() => fetchParticipantsList(filterData)}
      />
      <CSVUploadModal modal={csvModal} toggle={toggleCSV} batchId={batchId} />
      <div className="page-content table-main-participant-list">
        <div className="container-fluid">
          <div className="text-icon-back">
            <MdArrowBackIos
              style={{ cursor: "pointer" }}
              onClick={() => navigate(-1)}
            />{" "}
            <Breadcrumbs
              isBack="yes"
              title={props.t("Participants")}
              breadcrumbItem={props.t("Batches List")}
              breadcrumbItemText={props.t("Manage Participants")}
            />
          </div>
          <Row>
            <Col lg="12">
              <Row className="mb-2 d-flex show-select justify-spacebetween">
                <Col md={1} className="me-4 space-marg-rem">
                  <select
                    className="form-select custm-select"
                    onChange={(e) => handleLimit(e.target.value)}
                  >
                    <option value="25">{props.t("Show")} 25</option>
                    <option value="50">{props.t("Show")} 50</option>
                    <option value="75">{props.t("Show")} 75</option>
                    <option value="100">{props.t("Show")} 100</option>
                  </select>
                </Col>
                <Col md={2}>
                  <div className="search-box d-inline-block">
                    <div className="position-relative">
                      <label htmlFor="search-bar-0" className="search-label">
                        <input
                          onChange={(e) => {
                            handleSearch(e.target.value);
                          }}
                          id="search-bar-0"
                          type="text"
                          className="form-control"
                          placeholder={props.t("Search") + "..."}
                        />
                      </label>
                      <i className="bx bx-search-alt search-icon"></i>
                    </div>
                  </div>
                </Col>
                <Col md={2}></Col>
                <Col md={6} className="text-end pe-0">
                  <div className="custm-btns">
                    {deleteIds?.length > 0 && (
                      <button
                        disabled={deleteIds?.length <= 0 ? true : false}
                        className="btn btn-lg btn-soft-danger"
                        onClick={onClickMultiDelete}
                        style={{
                          background: deleteIds?.length <= 0 ? "#82345573" : "",
                          color: deleteIds?.length <= 0 ? "white" : "",
                        }}
                      >
                        {props.t("Delete Selected")}
                      </button>
                    )}
                    <button
                      style={{ background: "#EC9E46 !important" }}
                      onClick={() => {
                        setCSVModal(true);
                      }}
                      className="btn btn-primary"
                    >
                      {props.t("Import Participants")}
                    </button>

                    <button
                      onClick={() => {
                        setModal(true);
                        setIsEdit(false);
                        SetItemData({});
                      }}
                      className="btn btn-primary"
                    >
                      {props.t("Add Participant")}
                    </button>
                    <Link
                      id="refresh"
                      onClick={() => fetchParticipantsList(filterData)}
                      className="btn btn-light me-1"
                    >
                      <i className="mdi mdi-refresh"></i>
                    </Link>
                    <UncontrolledTooltip placement="top" target="refresh">
                      {props.t("Refresh")}
                    </UncontrolledTooltip>
                  </div>
                </Col>
              </Row>
              <div className="table-responsive batches-list-remove-break">
                {loading ? (
                  <div className="loader d-flex justify-content-center align-items-center mt-5">
                    <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>{" "}
                    {props.t("Loading")}
                  </div>
                ) : (
                  <Table className="table mb-0">
                    <thead>
                      <tr>
                        <th>
                          <label className="radio-check-label">
                            <input
                              className="fill-checkbox"
                              type="checkbox"
                              checked={selectAll}
                              onClick={toggleSelectAll}
                              onChange={toggleSelectAll}
                            />
                            <span className="radio-check"></span>
                          </label>
                        </th>
                        {/* <th>#</th> */}
                        <th className="main-data-fix-batches">
                          {props.t("Username")}
                        </th>
                        <th>{props.t("Password")}</th>
                        <th>{props.t("First Name")}</th>
                        <th>{props.t("Last Name")}</th>
                        <th>{props.t("Language")}</th>
                        <th>{props.t("Invitation")}</th>
                        <th>{props.t("Reminder")}</th>
                        <th>{props.t("Scored")}</th>
                        <th>{props.t("Scored Date")}</th>
                        {/* <th>{props.t("Mail")}</th> */}
                        <th>{props.t("Peers Merge")}</th>
                        {/* <th>{props.t("Report")}</th> */}
                        {/* <th>{props.t("PDF")}</th> */}
                        <th>{props.t("Phone Number")}</th>
                        <th>{props.t("User Email")}</th>
                        <th>{props.t("Organization Code")}</th>
                        <th
                          style={{
                            textAlign: "center",
                            paddingRight: "25px",
                            position: "sticky",
                            right: "0px"
                          }}
                        >
                          {props.t("Action")}
                        </th>
                      </tr>
                    </thead>
                    {tableData?.participants?.length <= 0 ? (
                      <tr>
                        <td
                          colSpan="12"
                          className="text-center no-record-found"
                        >
                          {props.t("No Record Found")}
                        </td>
                      </tr>
                    ) : (
                      <tbody>
                        {(tableData?.participants || []).map((item, index) => (
                          <tr key={index}>
                            <td>
                              <label className="radio-check-label">
                                <input
                                  className="fill-checkbox"
                                  type="checkbox"
                                  onChange={toggleSelectAll}
                                  checked={deleteIds.includes(item.id)}
                                  onClick={() => onChangeSelectDelete(item.id)}
                                />
                                <span className="radio-check"></span>
                              </label>
                            </td>
                            {/* <td scope="row" className="drag-pointer">{item.id}</td> */}
                            <td>
                              <UncontrolledTooltip
                                placement="top"
                                target="userCopy"
                              >
                                {props.t("Click to Copy")}
                              </UncontrolledTooltip>
                              <CopyToClipboard
                                text={item?.username}
                                onCopy={handleCopy}
                              >
                                <span
                                  id="userCopy"
                                  style={{ cursor: "pointer" }}
                                >
                                  {item?.username || "..."}
                                </span>
                              </CopyToClipboard>
                              <br />
                            </td>
                            <td>
                              <UncontrolledTooltip
                                placement="top"
                                target="passwordCopy"
                              >
                                {props.t("Click to Copy")}
                              </UncontrolledTooltip>
                              <CopyToClipboard
                                text={item?.password}
                                onCopy={handleCopy}
                              >
                                <span
                                  id="passwordCopy"
                                  style={{ cursor: "pointer" }}
                                >
                                  {item?.password || "..."}
                                </span>
                              </CopyToClipboard>
                              <br />
                            </td>
                            <td>{item?.firstname || "..."}</td>
                            <td>{item?.lastname || "..."}</td>
                            <td>{item?.languageName || "..."}</td>
                            <td>
                              <label className="radio-check-label">
                                <input
                                  className="fill-checkbox"
                                  type="checkbox"
                                  checked={
                                    item?.invitation_sent == "Y" ? true : false
                                  }
                                  disabled
                                />
                                <span className="radio-check"></span>
                              </label>
                            </td>
                            <td>
                              <label className="radio-check-label">
                                <input
                                  className="fill-checkbox"
                                  type="checkbox"
                                  checked={
                                    item?.reminder_sent == "Y" ? true : false
                                  }
                                  disabled
                                />
                                <span className="radio-check"></span>
                              </label>
                            </td>
                            <td>
                              <label className="radio-check-label">
                                <input
                                  className="fill-checkbox"
                                  type="checkbox"
                                  checked={item?.scored == "Y" ? true : false}
                                  disabled
                                />
                                <span className="radio-check"></span>
                              </label>
                            </td>
                            <td>
                              {item?.scored_date
                                ? moment
                                  .utc(item?.scored_date)
                                  .format("DD-MM-YYYY")
                                : "..."}
                            </td>
                            {/* <td>{item?.scored_date ||  '...'}</td> */}

                            {/* <td>
                                                                    {
                                                                        mailData?.id === item?.id
                                                                            ?
                                                                            <button className="btn track-data mail-track">
                                                                                ...
                                                                            </button>
                                                                            :
                                                                            <button
                                                                                className="btn track-data"
                                                                                onClick={
                                                                                    () => {
                                                                                        setMailData(item)
                                                                                        onSendInvitationMail(item)
                                                                                    }
                                                                                }
                                                                            > {props.t("Mail")}
                                                                            </button>
                                                                    }

                                                                </td> */}
                            <td>
                              <UncontrolledTooltip
                                placement="top"
                                target="mergeTooltip"
                              >
                                {props.t("Merge")}
                              </UncontrolledTooltip>
                              <label
                                id="mergeTooltip"
                                className="radio-check-label"
                              >
                                <input
                                  className="fill-checkbox"
                                  type="checkbox"
                                  checked={
                                    item?.peers_merge == "Y" ? true : false
                                  }
                                  // disabled
                                  onClick={() => peersMerge(item?.id)}
                                />
                                <span className="radio-check"></span>
                              </label>
                            </td>
                            {/* <td>
                                                                    <button 
                                                                        className="btn track-data"
                                                                        onClick={
                                                                            () => {
                                                                                navigate('/participants/track/list', { state: { batchId: state?.batchData?.id, participantData: item } });
                                                                            }
                                                                        }
                                                                    > 
                                                                        {props.t("Track")}
                                                                    </button>
                                                                </td> */}
                            {/* <td><FaFilePdf size={20} style={{ color: "#EC9E46", cursor: "pointer" }} /></td> */}
                            <td>{item?.phone_number || "..."}</td>
                            <td>{item?.useremail || "..."}</td>
                            <td>{item?.organization_code || "..."}</td>
                            <td style={{ position: "sticky", right: "0px" }}>
                              <ul className="list-unstyled hstack gap-1 mb-0">
                                <li>
                                  <UncontrolledTooltip
                                    placement="top"
                                    target={`mailTooltip${item?.id}`}
                                  >
                                    {props.t("Mail")}
                                  </UncontrolledTooltip>
                                  {mailData?.id === item?.id ? (
                                    <button
                                      id={`mailTooltip${item?.id}`}
                                      className="btn track-data mail-track"
                                    >
                                      ...
                                    </button>
                                  ) : (
                                    <button
                                      id={`mailTooltip${item?.id}`}
                                      className="btn track-data"
                                      onClick={() => {
                                        setMailData(item);
                                        onSendInvitationMail(item);
                                      }}
                                    >
                                      {" "}
                                      <i className="bx bx-paper-plane"></i>
                                    </button>
                                  )}
                                </li>
                                <li>
                                  <UncontrolledTooltip
                                    placement="top"
                                    target={`trackTooltip${item?.id}`}
                                  >
                                    {props.t("Track")}
                                  </UncontrolledTooltip>
                                  <button
                                    id={`trackTooltip${item?.id}`}
                                    className="btn track-data"
                                    onClick={() => {
                                      navigate("/participants/track/list", {
                                        state: {
                                          batchId,
                                          participantData: item,
                                        },
                                      });
                                    }}
                                  >
                                    <i className="bx bx-line-chart"></i>
                                  </button>
                                </li>
                                <li>
                                  {/* {
                                                                                zipLoading && itemId == item?.id || item?.cronStatus === 'P' ? 
                                                                                        <span>
                                                                                                <i style={{marginLeft: "7px"}} className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>                                                                                        
                                                                                        </span>
                                                                                    :
                                                                                        <FaFilePdf onClick={() => onCreateZip(item?.id, item)} size={20} style={{ color: "#EC9E46", cursor: "pointer" }} />

                                                                            } */}
                                  {item.cronStatus != "P" && (
                                    <button
                                      className={`btn track-data track-data-reload ${item.cronFile ? "reload-icon-track" : ""
                                        }`}
                                      id={item.cronFile ? "generatePDF" : "createPDF"}
                                      onClick={() =>
                                        onCreateZip(item.id, "group")
                                      }
                                    >
                                      {item.cronFile ? (
                                        <MdRefresh />
                                      ) : (
                                        <i className="bx bxs-file-pdf"></i>
                                      )}
                                    </button>
                                  )}
                                </li>
                                <li>
                                  {item.cronStatus === "P" ? (
                                    <>
                                      <i
                                        id="generateLoading"
                                        style={{ marginLeft: "7px" }}
                                        className="bx bx-loader bx-spin font-size-16 align-middle me-2"
                                      ></i>
                                      <UncontrolledTooltip
                                        placement="top"
                                        target="generateLoading"
                                      >
                                        {props.t("Generating...")}
                                      </UncontrolledTooltip>
                                    </>
                                  ) : item.cronFile ? (
                                    <>
                                      {isDownloadPdf && participantId == item.id ? <i
                                        id="downloadPdf"
                                        style={{ marginLeft: "7px" }}
                                        className="bx bx-loader bx-spin font-size-16 align-middle me-2"
                                      ></i>
                                        :

                                        <>
                                          <MdDownloadForOffline
                                            id="download"
                                            onClick={() =>
                                              downloadPdf(item?.cronFile, item.id)
                                            }
                                            size={25}
                                            style={{
                                              color: "#62CEB0",
                                              cursor: "pointer",
                                            }}
                                          />
                                          <UncontrolledTooltip
                                            placement="top"
                                            target="download"
                                          >
                                            {props.t("Download")}
                                          </UncontrolledTooltip>
                                        </>

                                      }


                                      <UncontrolledTooltip
                                        placement="top"
                                        target="generatePDF"
                                      >
                                        {props.t("Regenerate")}
                                      </UncontrolledTooltip>
                                    </>
                                  ) : (
                                    <>
                                      {/* <span id="createPDF">
                                        {props.t("Create PDF")}
                                      </span> */}
                                      <UncontrolledTooltip
                                        placement="top"
                                        target="createPDF"
                                      >
                                        {props.t("Create PDF")}
                                      </UncontrolledTooltip>
                                    </>
                                  )}
                                </li>

                                <li>
                                  <span
                                    className="btn btn-sm btn-soft-info"
                                    onClick={() => {
                                      handleParticipantsClick(item);
                                    }}
                                  >
                                    <i
                                      className="bx bx-edit"
                                      id={`edittooltip${item?.id}`}
                                    />
                                    <UncontrolledTooltip
                                      placement="top"
                                      target={`edittooltip${item?.id}`}
                                    >
                                      {props.t("Edit")}
                                    </UncontrolledTooltip>
                                  </span>
                                </li>

                                <li>
                                  <span
                                    className="btn btn-sm btn-soft-danger"
                                    onClick={() => {
                                      onClickDelete(item);
                                    }}
                                  >
                                    <i
                                      className="bx bx-trash"
                                      id={`deletetooltip${item?.id}`}
                                    />
                                    <UncontrolledTooltip
                                      placement="top"
                                      target={`deletetooltip${item?.id}`}
                                    >
                                      {props.t("Delete")}
                                    </UncontrolledTooltip>
                                  </span>
                                </li>
                              </ul>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    )}
                  </Table>
                )}
              </div>
              {tableData?.records < filterData?.limit ? (
                ""
              ) : (
                <MyPagination
                  filterData={filterData}
                  recordsPerPage={filterData?.limit}
                  totalRecords={tableData?.records}
                  currentPage={currentPage}
                  onPageChange={(pageNumber) => {
                    setCurrentPage(pageNumber);
                    setFilterData((prevFilterData) => ({
                      ...prevFilterData,
                      page: pageNumber,
                    }));
                  }}
                />
              )}
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

ParticipantsList.propTypes = {
  history: PropTypes.object,
  t: PropTypes.any,
};
export default withTranslation()(ParticipantsList);
